import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import CreateTenant from './CreateTenant';
import type { Tenant } from '../../types/deal';
import { apiGetById } from '../../services/genesisApi/httpsMethods';
import { CircularProgress, Box } from '@mui/material';

const EditTenantWrapper = () => {
  const { tenantId } = useParams();
  const [tenant, setTenant] = useState<Partial<Tenant>>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTenant = async () => {
      try {
        const response = await apiGetById('tenant', Number(tenantId)); // API call
        if (response && response.success && response.data) {
          const data = response.data;
          setTenant(data[0]);
        }
      } catch (error) {
        console.error('Failed to fetch tenant', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTenant();
  }, [tenantId]);

  if (loading) {
    return (
      <Box sx={{ p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return <CreateTenant tenant={tenant} isEdit={true}/>;
};

export default EditTenantWrapper;
